"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RainbowCursor = void 0;
var Particle = /** @class */ (function () {
    function Particle(x, y) {
        this.position = { x: x, y: y };
    }
    return Particle;
}());
var RainbowCursor = /** @class */ (function () {
    function RainbowCursor(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        this.options = options;
        this.animationFrameId = null;
        this.cursor = { x: 0, y: 0 };
        this.particles = [];
        this.cursorsInitted = false;
        this.isRunning = false;
        this.abortController = new AbortController();
        this.onMouseMove = function (e) {
            if (!_this.isRunning)
                return;
            var rect = _this.element.getBoundingClientRect();
            _this.cursor.x = _this.options.element
                ? e.clientX - rect.left
                : e.clientX;
            _this.cursor.y = _this.options.element ? e.clientY - rect.top : e.clientY;
            if (!_this.cursorsInitted) {
                if (!_this.isRunning)
                    return;
                _this.cursorsInitted = true;
                for (var i = 0; i < _this.totalParticles; i++) {
                    _this.particles.push(new Particle(_this.cursor.x, _this.cursor.y));
                }
            }
        };
        this.onResize = function () {
            if (!_this.isRunning)
                return;
            if (!_this.canvas)
                return;
            if (_this.options.element) {
                _this.canvas.width = _this.element.clientWidth;
                _this.canvas.height = _this.element.clientHeight;
            }
            else {
                _this.canvas.width = window.innerWidth;
                _this.canvas.height = window.innerHeight;
            }
        };
        this.loop = function () {
            if (!_this.isRunning)
                return;
            if (!_this.isRunning || !_this.context || !_this.canvas)
                return;
            _this.context.clearRect(0, 0, _this.canvas.width, _this.canvas.height);
            var x = _this.cursor.x;
            var y = _this.cursor.y;
            var particleSets = [];
            _this.particles.forEach(function (p, i, arr) {
                var next = arr[i + 1] || arr[0];
                p.position.x = x;
                p.position.y = y;
                particleSets.push({ x: x, y: y });
                x += (next.position.x - x) * 0.4;
                y += (next.position.y - y) * 0.4;
            });
            _this.colors.forEach(function (color, idx) {
                _this.context.beginPath();
                _this.context.strokeStyle = color;
                if (particleSets.length) {
                    _this.context.moveTo(particleSets[0].x, particleSets[0].y + idx * (_this.size - 1));
                }
                particleSets.forEach(function (set, i) {
                    if (i !== 0)
                        _this.context.lineTo(set.x, set.y + idx * _this.size);
                });
                _this.context.lineWidth = _this.size;
                _this.context.lineCap = "round";
                _this.context.stroke();
            });
            // schedule next frame
            _this.animationFrameId = requestAnimationFrame(_this.loop);
        };
        this.element = options.element || document.body;
        this.colors = options.colors || [
            "#FE0000",
            "#FD8C00",
            "#FFE500",
            "#119F0B",
            "#0644B3",
            "#C22EDC",
        ];
        this.size = options.size || 3;
        this.totalParticles = options.length || 20;
        this.cursor.x = window.innerWidth / 2;
        this.cursor.y = window.innerHeight / 2;
        this.start();
    }
    RainbowCursor.prototype.start = function () {
        if (this.isRunning)
            return;
        this.isRunning = true;
        this.initCanvas();
        this.bindEvents();
        this.animationFrameId = requestAnimationFrame(this.loop);
    };
    RainbowCursor.prototype.initCanvas = function () {
        this.canvas = document.createElement("canvas");
        this.context = this.canvas.getContext("2d");
        this.canvas.style.position = this.options.element
            ? "absolute"
            : "fixed";
        this.canvas.style.top = "0px";
        this.canvas.style.left = "0px";
        this.canvas.style.pointerEvents = "none";
        this.canvas.style.zIndex = this.options.zIndex || "9999999999";
        this.canvas.classList.add("rainbow-cursor-canvas");
        if (this.options.element) {
            this.options.element.appendChild(this.canvas);
            this.canvas.width = this.options.element.clientWidth;
            this.canvas.height = this.options.element.clientHeight;
        }
        else {
            document.body.appendChild(this.canvas);
            this.canvas.width = window.innerWidth;
            this.canvas.height = window.innerHeight;
        }
    };
    RainbowCursor.prototype.bindEvents = function () {
        var signal = this.abortController.signal;
        this.element.addEventListener("mousemove", this.onMouseMove, {
            signal: signal,
        });
        window.addEventListener("resize", this.onResize, { signal: signal });
    };
    RainbowCursor.prototype.destroy = function () {
        this.abortController.abort();
        this.abortController = new AbortController(); // allow restarting later
        this.isRunning = false;
        if (this.animationFrameId !== null) {
            cancelAnimationFrame(this.animationFrameId);
        }
        this.animationFrameId = null;
        document
            .querySelectorAll(".rainbow-cursor-canvas")
            .forEach(function (el) { return el.remove(); });
        this.canvas = undefined;
        this.context = undefined;
        this.particles = [];
        this.cursorsInitted = false;
    };
    return RainbowCursor;
}());
exports.RainbowCursor = RainbowCursor;
